import { Component, Input, OnInit,ViewChild } from '@angular/core';
import { ConsoleService } from 'src/app/services/console/console.service';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import {SafeStyle , DomSanitizer} from '@angular/platform-browser';
import { IonSlides } from '@ionic/angular';
import { encodeURL } from 'src/app/services/parseURL';

@Component({
  selector: 'app-widget-categories-carousel-one',
  templateUrl: './widget-categories-carousel-one.component.html',
  styleUrls: ['./widget-categories-carousel-one.component.scss'],
})
export class WidgetCategoriesCarouselOneComponent implements OnInit{

  @ViewChild('categoriesSlider', {
    static: false
}) public categoriesSlider: IonSlides;

  @Input() widgetTitle: any;
  @Input() widgetID: any;
  @Input() regionId: any;
  @Input() categories: any;
  @Input() style: any;

  widgetStyle:any;
  background:any ;


  SlideOpts:any = {
    initialSlide: 1,
    speed: 400,
    autoplay: false,
    spaceBetween: 16,
    slidesPerView:5,
};

  constructor(private widgetsService: WidgetsService, private consoleService: ConsoleService,private domSanitizer:DomSanitizer) { }


  async ngOnInit() {
    this.setStyle();
  }

  nextSlide() {
    this.categoriesSlider.slideNext();
}
prevSlide() {
    this.categoriesSlider.slidePrev();
}


  async setStyle(){

        let lgColClass = this.style.itemStyle.gridColumn.lg;
        let mdColClass = this.style.itemStyle.gridColumn.md;
        let smColClass = this.style.itemStyle.gridColumn.sm;
        this.SlideOpts = {
            slidesPerView:lgColClass,
            breakpoints: {
        576: {
            slidesPerView: smColClass
        },
        1366: {
            slidesPerView: mdColClass
        }
    }
        }
}

	urlName(name: string) {
        return encodeURL(name)
    }

}
